// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G9Ti","label":"styles_label__2TIkB"};